import { Box } from '@primer/react';
import {
    BarElement,
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LinearScale,
    Title,
    Tooltip,
} from 'chart.js';
import { useMemo } from 'react';
import { Pie } from 'react-chartjs-2';
import Block from './Block';
import { useColors } from '../../hooks/useColors';
import { useThongKeSiSo } from '../../hooks/useThongKeSiSo';

// Đăng ký các thành phần cho biểu đồ
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const ChartSiSoTheoTrangThai = () => {
    const { colors } = useColors();
    const { dmTrangThais } = useThongKeSiSo();
    const dataSource = useMemo(() => {
        let result: any[] = [];
        dmTrangThais.forEach((value, key) => {
            result.push({
                id: value.id,
                text: value.name,
                so_luong: value.so_luong
            })

        })
        return result;
    }, [dmTrangThais])

    // Chuẩn bị dữ liệu cho Bar Chart
    const data = {
        labels: dataSource.map(item => item.text), // Nhãn các môn học
        datasets: [
            {
                label: '',
                data: dataSource.map(item => item.so_luong), // Điểm tương ứng
                backgroundColor: dataSource.map((t, idx) => {
                    return colors[idx % colors.length].hex;
                }),
                borderColor: dataSource.map((t, idx) => {
                    return colors[idx % colors.length].hex;
                }),
                borderWidth: 1,
                barThickness: 20, // Độ dày của thanh Bar (pixel)
                maxBarThickness: 30, // Độ dày tối đa của mỗi Bar
                borderRadius: 4, // Bo tròn góc tha
            },
        ],
    };
    const options: any = {
        responsive: true,
        plugins: {
            legend: {
                position: 'right',
                display: false,
            },
            title: {
                display: false,
                text: 'Pie Chart Example',
            },
            datalabels: {
                color: '#fff',
                font: {
                    weight: 'bold',
                    size: 13,
                },
            },
        },
    };
    return (
        <>
            <Box sx={{ fontSize: 24, fontWeight: 600 }}>Trạng thái học sinh</Box>
            <Box sx={{ fontSize: "1rem", color: "fg.muted" }}>Số học sinh theo các trạng thái</Box>
            <Box sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mt: 3
            }}>
                <Box sx={{
                    flex: 1,
                    display: 'flex',
                    justifyContent: "center"
                }}>
                    <Box sx={{ height: "180px" }}>
                        <Pie data={data} options={options} />
                    </Box>
                </Box>
                <Box sx={{ flex: 1 }}>
                    <Box sx={{
                        display: "flex",
                        flexDirection: "column"
                    }}>
                        {dataSource.map((t, idx) => {
                            return <Box key={idx} sx={{
                                display: "flex",
                                mb: 2
                            }}>
                                <Box sx={{
                                    backgroundColor: colors[idx % colors.length].hex,
                                    width: "24px",
                                    height: "24px",
                                    borderRadius: "4px",
                                }}>&nbsp;</Box>
                                <Box sx={{
                                    ml: 2,
                                    fontWeight: "600",
                                    flex: 1,
                                    whiteSpace: "break-spaces"
                                }}>{t.text} : {t.so_luong} học sinh</Box>
                            </Box>
                        })}
                    </Box>
                </Box>
            </Box>
        </>
    );
};

export default ChartSiSoTheoTrangThai;